const DISCORD_INVITE_LINK = "https://discord.com/invite/formfunction";

export default DISCORD_INVITE_LINK;
